import {PlayParticipantsConfig} from "../providers/PlayParticipantsConfig";
import {assign, cloneDeep} from "lodash";

/**
 * Main component for PlayParticipants.
 * Provide this component with a leagueId and it will
 * render a list of league participants along with controls.
 */
export class PlayParticipantsContainerController {
    public leagueId: number;
    public league: any;
    public participants: any[];

    public sorting = {
        type: "name",
        order: "asc"
    };

    public filtering = {
        name: null,
        region: null,
        statusFilter: null
    };

    public static $inject = ["$location", "LeagueService", "PlayParticipants", "$scope"];
    constructor(
        private $location: angular.ILocationService,
        private LeagueService,
        private PlayParticipants: PlayParticipantsConfig,
        private $scope: angular.IScope
    ) {
    }

    public $onInit() {
        if (this.PlayParticipants.permalinksEnabled) {
            this.locationChangeHandler();
            this.$scope.$on("$locationChangeSuccess", this.locationChangeHandler.bind(this));
        }
    }

    public $onChanges(changes) {
        if (changes.leagueId && this.leagueId) {
            this.LeagueService.getLeague(this.leagueId).then((league: any) => {
                this.league = league.rawObject;
            });

            this.LeagueService.getLeagueContestants(this.leagueId).then(participants => {
                this.participants = participants.map((participant: any) => {
                    return participant.getRawData();
                });
            });
        }
    }

    /**
     * Toggle the sorting of Participants.
     * @param type Specify what to sort (name | seed).
     * @param order  Specify how to sort (asc | desc).
     */
    public setSorting(type: string, order: string) {
        let sorting = cloneDeep(this.sorting);

        type = (type !== "name" && type !== "seed") ? "name" : type;
        order = (order !== "asc" && order !== "desc") ? "asc" : order;

        sorting.type = type;
        sorting.order = order;

        this.sorting = sorting;

        this.updateLocation("type", type);
        this.updateLocation("order", order);
    }

    /**
     * Set participants name filter.
     * @param name The substring the participants we want to show have to contain.
     */
    public filterByName(name: string) {
        this.filtering = this.filtering = assign({}, this.filtering, {
            name: name !== "" ? name : null
        });

        this.updateLocation("nameFilter", this.filtering.name);
    }

    /**
     * Set participants region filter.
     * @param region The countries we want to show participants of.
     */
    public filterByRegion(region: string) {
        this.filtering = this.filtering = assign({}, this.filtering, {
            region: region ? region : undefined // undefined since null is international
        });

        this.updateLocation("regionFilter", this.filtering.region);
    }

    /**
     * Set participants status filter.
     * If true, filter participants by status.
     * @param filterByStatus Specify if participants should be filtered by status.
     */
    public filterByStatus(filterByStatus: boolean) {
        this.filtering = this.filtering = assign({}, this.filtering, {
            statusFilter: filterByStatus ? filterByStatus : null
        });

        this.updateLocation("statusFilter", this.filtering.statusFilter);
    }

    /**
     * Reset all filters.
     */
    public resetFilters() {
        this.filterByName(null);
        this.filterByRegion(null);
        this.filterByStatus(null);
    }

    /**
     * Handle url changes.
     * We don't want to call this when url gets changed by the app itself. But don't know how!
     */
    private locationChangeHandler() {
        const type = this.$location.search().type;
        const order = this.$location.search().order;

        this.filterByName(this.$location.search().nameFilter);
        this.filterByRegion(this.$location.search().regionFilter);
        this.filterByStatus(this.$location.search().statusFilter);

        this.setSorting(type, order);
    }

    /**
     * Update $location if permalinks are enabled.
     * @param key   Key for $location.search.
     * @param value Value for $location.search.
     */
    private updateLocation(key: string, value: any) {
        if (this.PlayParticipants.permalinksEnabled) {
            // Update they key with value.
            this.$location.search(key, value).replace();
        }
    }
}
